import { render, staticRenderFns } from "./TradeContractTableForData.vue?vue&type=template&id=51d2f9b4&"
import script from "./TradeContractTableForData.vue?vue&type=script&lang=js&"
export * from "./TradeContractTableForData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports